export const getStament = async (resource) => {
    let stablishment;
    await resource
      .get(`api/${localStorage.getItem('perfil')}/stament`)
      .then(
        (response) => {
          console.log(response);
          stablishment = response.body.data;
        },
        (response) => {
          console.log(response);
        }
      );
    return stablishment;
  }
  